import app from 'app';
import 'selectize';

const TopicsView = Backbone.View.extend({
  SPLIT_DELIMITER: ',',
  onClose: function () {
    // TODO: destroy plugins and any non-default additional data
    this._destroySelectize(this.$selectizeContainer);
  },
  // TODO: ADD already existing tags to selectize
  initialize: function () {
    this.$container = this.$el.find('#topicsViewPlaceholder');
    this.$selectizeContainer = this.$container.find('#selectizeContainer');
    this.template = app.compileTemplate.$('#singleTopic-tmpl');
  },
  _destroySelectize: function ($el) {
    if ($el && $el.length && $el[0].selectize) {
      $el[0].selectize.destroy();
    }
  },
  _selectize: function ($el) {
    this._destroySelectize($el);
    $el.selectize({
      placeholder: app.culture.metadataEditor.tagsEmpty,
      delimiter: this.SPLIT_DELIMITER,
      persist: false,
      create: function (input) {
        return {
          value: input,
          text: input,
        };
      },
      render: {
        item: function (data, escape) {
          return (
            '<div class="topic item">' +
            escape(data[$.fn.selectize.defaults.labelField]) +
            '  <i class="delete-tag wticon wticon-cross2"></i></div>'
          );
        },
      },
    });
  },
  /**
   * Render task view inner html (yet being DOM-detached)
   */
  render: function () {
    return this;
  },

  /**
   * Execute additional DOM related initialization when task view markup is attached to the DOM
   */
  domReady: function () {
    this._selectize(this.$selectizeContainer);
    //        ("disableSelection" in this.$el) && this.$el.find('.topic').disableSelection();
    //        this.$el.find("i[class^=icon-]").show();
    //        this.$lblDone.show();
  },

  events: {
    'click .item i.delete-tag': 'removeTag',
    //        "click .topic": "_toggleTopic",
  },

  /*
   _toggleTopic: function (e) {
   e.preventDefault(); e.stopPropagation();

   var target = e.target;
   if (/i/i.test(target.tagName)) {
   target = target.parentNode || target.parentElement;
   }
   var $topic = $(target),
   $icon = $topic.find("i"),
   $input = $topic.find("input");
   // change styling
   $topic.toggleClass("btn-selected");
   $icon.toggleClass("icon-ok");
   // draw and apply to model
   $input.prop("checked", !$input.prop("checked"));
   $topic.data("topic").topic.valid = $input.prop("checked");

   },
   */
  removeTag: function (e) {
    const removeItemValue = $(e.currentTarget).parent().data('value');
    if (!!removeItemValue && this.$selectizeContainer[0].selectize) {
      this.$selectizeContainer[0].selectize.removeItem(removeItemValue);
    }
  },

  isValid: function () {
    return !!this.$selectizeContainer.val() || true;
  },

  /**
   * Collect task related data that should be passed to the server
   * @return {Object}, non-empty object required
   */
  toJSON: function () {
    const topics = this.$selectizeContainer.val();
    const finalTopics = {
      seoTags: topics,
    };

    return finalTopics;
  },
});
export default TopicsView;
